// extracted by mini-css-extract-plugin
export default {"item":"MetricItem_item__xVSco","badge":"MetricItem_badge__vLqwh"};